import React, { Component } from 'react';
import axios from "axios";
import Api from "../../customlib/Api";
import moment from "moment";
import ExportLeadsReport from '../ContactLeadsReport/ExportLeadsReport';
import Global from "../../customlib/Global"


import { makeStyles } from '@mui/styles';
import {Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Collapse, IconButton, Box, Typography, CircularProgress, Tooltip, Autocomplete, TextField, Button, LinearProgress, Dialog, DialogTitle, DialogContent, Grid, FormControl, InputLabel, Select, MenuItem, DialogActions, ToggleButtonGroup, ToggleButton} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Edit, QuestionAnswer, Refresh, Search } from '@mui/icons-material';
import DateRangePicker from '../../customlib/DateRangePicker';
import MessageList from '../MessageList';
import ExportTeleDiChatCustomer from '../ContactLeadsReport/ExportTeleDichatCustomer';
import InputFiveWhys from './InputFiveWhys';
import InputHasilTraining from './InputHasilTraining';

class ModulTrainingReport extends Component {
    VIEW_MODE_SUMMARY = "SUMMARY";
    VIEW_MODE_ANALISA_FIVE_WHYS = "ANALISA_FIVE_WHYS";

    state = { 
        contactLeads : [],
        sales : [],
        contactSelectedToUpdate: [],
        checkAll : null,
        // startDate: moment(new Date()).format("YYYY-MM-DD"),
        // endDate: moment(new Date()).format("YYYY-MM-DD"),
        startDate: moment(new Date()).format("YYYY-MM-DD"),
        endDate: moment(new Date()).format("YYYY-MM-DD"),
        page: 0,
        rowsPerPage: 30,
        value: '0',
        isTeleReport: true,
        additionalData: null,
        isLoading: false,
        currentConversation: null,
        totalLeads: 0,
        avgAll: 0,
        contactLeads24Hours: [],
        salesData: [],
        teleId: 0,
        teleName: "",
        filterCustomerName: "",
        debounceTimeout: null,
        showDialogInput: false,
        selectedCustomer: null,
        viewMode: this.VIEW_MODE_SUMMARY //SUMMARY, ANALISA_FIVE_WHYS
    }

    componentDidMount() {
        this.getContactLeads();
        this.getSalesTeleUsers();
    }

    getContactLeads = () => {
      console.log("STARTDATE : ",this.state.startDate);
      var userData = Global.get();
      console.log("USERDATA : ", userData, userData.admin, Global.isTeleAdmin(), Global.isAdminTeleUser(), userData.user.id);
      console.log("USERDATA", userData);

      var params = {};

      console.log("PARAMS", params);

      this.setState({
            contactLeads: [],
            additionalData: null,
            isLoading: true
          }, () => {});

      axios
        .post(Api.teleTrainingReport(), params, Api.getRequestHeader())
        .then((response) => {
          console.log("TRAININGREPORT : ", response.data);
          
          var tmpContactLeads = response.data.data;
          var additionalData = response.data.additional_data;
          let totalLeads = 0;

          // tmpContactLeads = tmpContactLeads.filter(item => item.leads && item.leads.length > 0);
          
          if(additionalData && additionalData.isLeader === true){
            tmpContactLeads = tmpContactLeads.filter(element => additionalData.members.includes(element.salesId));
          }else if(userData.admin === false && Global.isTeleAdmin() === false && Global.isAdminTeleUser() === false){
            console.log("LOG___", userData);
            tmpContactLeads = tmpContactLeads.filter(element => element.salesId === userData.user.id);
          }

          var totalAvgResponseTime = 0;
          tmpContactLeads.forEach(training => {
            training.totalModul = training.results.length;
            training.totalPaham = training.results.filter(item => item.paham === true).length;

            training.persentase = training.totalModul > 0 ? (training.totalPaham/training.totalModul*100).toFixed(2).replace(".00", "") : 0;

          });

          this.setState({
            // contactLeads: [],
            additionalData: response.data.additional_data.length > 0 ? response.data.additional_data[0] : null,
            isLoading: false,
            contactLeads: tmpContactLeads, 
            totalLeads: totalLeads, 
          }, () => {
            // this.getLoginLogs();
          });
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    };

    getSalesTeleUsers = () => {
    
      const params = {
          slugRoles: ["tele-leader-new", "admin-tele", "account-executive"]
          // slugRole: "account-executive"
      };

      axios
      // .post(Api.getSalesTeleUserList(), {}, Api.getRequestHeader())
      .post(Api.userBySlugRoles(), params, Api.getRequestHeader())
      .then((response) => {
          console.log("SALESTELEUSER : ", response.data.data);
          this.setState({salesData: response.data.data});
      })
      .catch((error) => {
          console.error("There was an error!", error);
      });
  };

    getWaMessages = (contactData) => {
      console.log("CONTACTDATA : ", contactData);
      if(contactData.fromNumber === ""){
        return;
      }
  
      this.setState({isLoading: true}, ()=>{
        const params = {
          from: contactData.fromNumber,
        };
        console.log("PARAMSWAMESSAGE", params);
    
        axios
          .post(Api.messagesList(), params, Api.getRequestHeader())
          .then((response) => {
            console.log("YOUR_MESSAGES",response.data);
            
            const responseData = response.data;
              
            const clonedMyCust = [...this.state.listMycustomer];
            let myCust = clonedMyCust.filter((cust) => cust.from===contactData.fromNumber);

            if(myCust.length > 0){
                myCust[0].messages = responseData.data;
            }

            this.setState({listMycustomer: clonedMyCust});
            
          })
          .catch((error) => {
            this.setState({ errorMessage: error.message, isLoading: false });
            console.error("There was an error!", error);
          });
      });
  
      
    };

    handleShowMessages = (conversation) => {
      this.setState({currentConversation: conversation});
      this.scrollToElement();
  }

    handleStartDateChange = (event) => {
        var formatStartDate = event.target.value.replace("/", "-");
        console.log(formatStartDate);
        this.setState({ startDate:  formatStartDate}, this.getContactLeads);
        // this.state.startDate = formatStartDate;
        // this.getContactLeads();
        // console.log(this.state.email);
    };

    handleEndDateChange = (event) => {
        var formatStartDate = event.target.value.replace("/", "-");
        console.log(formatStartDate);
        this.setState({ endDate:  formatStartDate}, this.getContactLeads);
        // this.getContactLeads();
        // console.log(this.state.email);
    };

    handleDateChanged = (rangeDate) => {

      let startDate =  moment(rangeDate[0]).format("YYYY-MM-DD");
      let endDate =  moment(rangeDate[1]).format("YYYY-MM-DD");

      console.log("START : ", startDate, ", END : ", endDate);

      this.setState({ startDate: startDate, endDate:  endDate}, this.getContactLeads);
    }

    columns = [
        { id: 'salesName', label: 'Sales', minWidth: 170 },
        { id: 'avgResponse', label: 'Avg Response', minWidth: 100, align: "right" },
        { id: 'leadsCountTotal', label: 'Jumlah Customer', minWidth: 100, align: "right" },
        { id: 'kurangSemenit', label: '< 1 Menit', minWidth: 100, align: "right" },
        { id: 'lebih semenit', label: '> 1 Menit', minWidth: 100, align: "right" }
        // { id: 'leadsCountLavender', label: 'Fu Lavender', minWidth: 100 },
        // { id: 'leadsCountHsm', label: 'Fu HSM', minWidth: 100 }
    ];

    revElement = React.createRef();

    scrollToElement = () => {
      this.revElement.current?.scrollIntoView()
    }

    handleSelectionChanged = (salesName) => {
        console.log("FINDSELECTION : ", salesName);
        const salesData = [...this.state.salesData];
        let selected = salesData.filter((sales) => sales.name===salesName);
        console.log("FINDSELECTION : ", selected);
  
        if(selected.length > 0){
            this.setState({
              teleId: selected[0].id,
              teleName: selected[0].name
            }, () => {
              this.getContactLeads()
            });
            console.log(selected[0].id);
            console.log(selected[0].name);
        }else{
            this.setState({
              teleId: 0,
              teleName: ""
            }, () => {
              this.getContactLeads()
            });
        }
  
    }

    handleFilterCustomerChange = (event) => {

      let oldDebounceTimeout = this.state.debounceTimeout;
      clearTimeout(oldDebounceTimeout);

      // Menunda request untuk 500ms setelah pengguna berhenti mengetik
      let newDebounceTimeout = setTimeout(() => {
              this.getContactLeads();
      }, 1000);
      this.setState({filterCustomerName: event.target.value, debounceTimeout: newDebounceTimeout});
    }

    toggleShowDialogInput = (selected) => {
      this.setState({showDialogInput: !this.state.showDialogInput, selectedCustomer: {...selected}});
    }

    handleViewModeChange = (event, viewMode) => {
      this.setState({viewMode: viewMode});
    }

    render() { 
        return ( 
          <Paper style={{paddingTop:10, paddingBottom: 10, margin: "10px"}} elevation={3}>
            
            <Box>
              <div className="panel panel-default">
                  <div className="panel-heading">
                      <div className="panel-title">
                          {/* <h1>Setup Contact</h1> */}
                      </div>
                  </div>
                  <div className="panel-body">
                    <div className="row">
                    <div className={this.state.currentConversation !== null ? "col-8" : "col-12"}>
                      <div className="row align-items-center">
                          <div className="col-4"></div>
                          <div className="col-4 text-center">
                            <h3>Report Training</h3>
                          </div>
                          <div className="col-4 text-right">
                            <Button disabled={this.state.isLoading} variant='contained' color='primary' onClick={() => {this.getContactLeads()}}>
                              <Refresh />
                            </Button>
                          </div>
                      </div>
                      <br />

                      {
                      this.state.additionalData !== null ? (
                        <>
                          <Paper>
                            <div className="container">
                              Total FU bulan {moment(this.state.additionalData.end).format("MMMM")} : {this.state.additionalData.totalLeads} FU
                            </div>
                          </Paper>
                          <br />
                        </>
                      ): (<></>)
                    }
                      <Paper className="root" elevation={0}>
                        {
                          this.state.isLoading && <LinearProgress />
                        }
                        {
                          this.state.viewMode === this.VIEW_MODE_SUMMARY && (
                            <TableContainer>
                              <Table aria-label="sticky table" size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell >Nama Tele</TableCell>
                                        <TableCell width={"15%"} align='center'>Total Modul</TableCell>
                                        <TableCell width={"15%"} align='center'>Sudah Paham</TableCell>
                                        <TableCell width={"15%"} align='center'>%</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.contactLeads.map((row) => {
                                        return (
                                          <TableRow>
                                            <TableCell>{row.userName}</TableCell>
                                            <TableCell align='center'>{row.totalModul}</TableCell>
                                            <TableCell align='center'>{row.totalPaham}</TableCell>
                                            <TableCell align='center'>{row.persentase}%</TableCell>
                                        </TableRow>
                                        )
                                    })}
                                </TableBody>

                              </Table>
                            </TableContainer>
                          )
                        }

                        {
                          this.state.viewMode === this.VIEW_MODE_ANALISA_FIVE_WHYS && (
                            <Box sx={{overflowX: "auto"}}>
                              <TableContainer sx={{minWidth: "150%"}} component={"paper"}>
                                <Table stickyHeader aria-label="sticky table" size="small" >
                                  <TableHead>
                                      <TableRow>
                                          <TableCell width={"200px"}>Tanggal</TableCell>
                                          <TableCell width={"200px"}>Nama Customer</TableCell>
                                          <TableCell width={"200px"}>Nama Tele</TableCell>
                                          <TableCell width={"200px"}>Issue</TableCell>
                                          <TableCell width={"200px"}>Why 1</TableCell>
                                          <TableCell width={"200px"}>Why 2</TableCell>
                                          <TableCell width={"200px"}>Why 3</TableCell>
                                          <TableCell width={"200px"}>Why 4</TableCell>
                                          <TableCell width={"200px"}>Why 5</TableCell>
                                          <TableCell width={"200px"}>Issue Description</TableCell>
                                          <TableCell width={"200px"}>Solution</TableCell>
                                          <TableCell width={"200px"}>Contoh Kasus</TableCell>
                                          <TableCell width={"200px"}>Mengerti?</TableCell>
                                          <TableCell width={"200px"}>Skenario</TableCell>
                                          <TableCell></TableCell>                                          
                                      </TableRow>
                                  </TableHead>
                                  <TableBody>
                                      {this.state.contactLeads.map((row) => {
                                            return row.leads.map(lead => {
                                              return (
                                                <TableRow>      
                                                  <TableCell width={"200px"} sx={{fontSize: "11px"}}>{Global.formatDateTimeToStrDate(lead.created_at)}</TableCell>
                                                  <TableCell width={"200px"} sx={{fontSize: "11px"}}>{lead.fromName}</TableCell>
                                                  <TableCell width={"200px"} sx={{fontSize: "11px"}}>{lead.assignToUserName}</TableCell>
                                                  <TableCell width={"200px"} sx={{fontSize: "11px"}}>{lead.five_whys?.issue}</TableCell>
                                                  <TableCell width={"200px"} sx={{fontSize: "11px"}}>{lead.five_whys?.whys[0]?.why_value}</TableCell>
                                                  <TableCell width={"200px"} sx={{fontSize: "11px"}}>{lead.five_whys?.whys[1]?.why_value}</TableCell>
                                                  <TableCell width={"200px"} sx={{fontSize: "11px"}}>{lead.five_whys?.whys[2]?.why_value}</TableCell>
                                                  <TableCell width={"200px"} sx={{fontSize: "11px"}}>{lead.five_whys?.whys[3]?.why_value}</TableCell>
                                                  <TableCell width={"200px"} sx={{fontSize: "11px"}}>{lead.five_whys?.whys[4]?.why_value}</TableCell>
                                                  <TableCell width={"200px"} sx={{fontSize: "11px"}}>{lead.five_whys?.issueDescription}</TableCell>
                                                  <TableCell width={"200px"} sx={{fontSize: "11px"}}>{lead.five_whys?.solution}</TableCell>
                                                  <TableCell width={"200px"} sx={{fontSize: "11px"}}>{lead.five_whys?.issueCategory}</TableCell>
                                                  <TableCell width={"200px"} sx={{fontSize: "11px"}}>{lead.five_whys?.todo}</TableCell>
                                                  <TableCell width={"200px"} sx={{fontSize: "11px"}}>{lead.five_whys?.status}</TableCell>
                                                  <TableCell>
                                                    <Tooltip title="Input Analisa">
                                                      <IconButton size='small' color='primary' onClick={() => this.toggleShowDialogInput(lead)}>
                                                        <Edit sx={{width: "18px", height: "18px"}} />
                                                      </IconButton>
                                                    </Tooltip>
                                                  </TableCell>
                                                </TableRow>)
                                            })
                                      })}
                                      <TableRow>
                                        <TableCell />
                                        <TableCell style={{fontWeight: "bold"}}>Jumlah customer chat ke Tele berlabel {Global.labelCancel()}</TableCell>
                                        <TableCell style={{fontWeight: "bold"}}>{this.state.totalLeads}</TableCell>
                                      </TableRow>
                                  </TableBody>

                                </Table>
                              </TableContainer>
                            </Box>
                          )
                        }  
                          
                      </Paper>
                    </div>
                    <div className="col-4" style={{maxHeight: "50vh", overflowY: "none"}}>
                        {
                        this.state.currentConversation !== null ? (
                            <div className='text-right'>
                              <div className="btn btn-block btn-danger" onClick={() => {this.handleShowMessages(null)}}>Close Chat</div>
                            </div>
                        ) : (<></>)
                        }
                        {
                        this.state.currentConversation !== null ? (
                            <Paper className='root'>
                                <MessageList
                                    onUpdateReadCounter = {()=>{}}
                                    onNewIncomingMessage={()=>{}}
                                    onUpdateConversations={()=>{}}
                                    onUpdateCsHelpState={()=>{}}
                                    currentConversation={this.state.currentConversation}
                                    onUpdateContactLabelState={()=>{}}
                                    onClearCurrentConversation = {()=>{}}
                                    onUpdateSlow={()=>{}}
                                    onUpdateJustRead={()=>{}}
                                    onUpdateUnfinishedChat={()=>{}}
                                    onResetUnreadCounter={()=>{}}
                                    conversationList={[]}
                                    logoutHandler={()=>{}}
                                    onSaveCustomerName={()=>{}}
                                    style={{maxHeight: "50vh", overflowY: "none"}}
                                />
                            </Paper>
                            
                        ) : (<></>)
                        }
                      </div>
                    </div>
                  </div>
                  <div className="panel-footer">
                  </div>
              </div>
            </Box>
                

            <Dialog maxWidth="lg" fullWidth onClose={this.toggleShowDialogInput} open={this.state.showDialogInput}>
            {/* <Dialog maxWidth="sm" fullWidth onClose={this.toggleShowDialogInput} open={true}> */}
              <DialogTitle>Input Hasil FU</DialogTitle>
              <DialogContent>
                {
                  this.state.showDialogInput && <InputHasilTraining onClose={this.toggleShowDialogInput} data={this.state.selectedCustomer} onReload={this.getContactLeads} />
                }
              </DialogContent>
            </Dialog>
          </Paper>
         );
    }
}
 
export default ModulTrainingReport;

const useRowStyles = makeStyles({
    root: {
      '& > *': {
        borderBottom: 'unset',
      },
    },
});

function Row(props) {
    const { row, onInputFiveWhys } = props;
    const [open, setOpen] = React.useState(false);
    const classes = useRowStyles();
  
    return (
      <React.Fragment>
        <TableRow className={classes.root}>
          <TableCell>
            <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell component="th" scope="row">{Global.formatDateTimeToStrDate(row.created_at)}</TableCell>
          <TableCell align="left">{row.fromName}</TableCell>
          <TableCell align="left">{row.assignToUserName}</TableCell>
          <TableCell align="left">{row.five_whys?.issue}</TableCell>
          <TableCell align="left">{row.five_whys?.issueDescription}</TableCell>
          <TableCell align="left">{row.five_whys?.solution}</TableCell>
          <TableCell align="center">
            <Tooltip title="Lihat Chat">
                <QuestionAnswer style={{cursor: "pointer"}} className="text-danger" onClick={() => {props.handleShowMessages(row.contactFormatted)}}  />
            </Tooltip>
          </TableCell>
          <TableCell align="center">{[null, undefined].includes(row.training_result?.paham) ? "-" : row.training_result?.paham === true ? "Ya" : "Tidak"}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Paper margin={1} elevation={2} sx={{padding: "5px"}}>
                <Box>
                  <Typography variant="h6" gutterBottom component="div">
                    Why
                  </Typography>

                  <Table size="small" aria-label="purchases">
                    <TableHead>
                      <TableRow>
                        <TableCell>Why 1</TableCell>
                        <TableCell>Why 2</TableCell>
                        <TableCell>Why 3</TableCell>
                        <TableCell>Why 4</TableCell>
                        <TableCell>Why 5</TableCell>
                        <TableCell>Skenario</TableCell>
                        <TableCell width={"30px"}></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell>{row.five_whys?.whys[0]?.why_value}</TableCell>
                        <TableCell>{row.five_whys?.whys[1]?.why_value}</TableCell>
                        <TableCell>{row.five_whys?.whys[2]?.why_value}</TableCell>
                        <TableCell>{row.five_whys?.whys[3]?.why_value}</TableCell>
                        <TableCell>{row.five_whys?.whys[4]?.why_value}</TableCell>
                        <TableCell>{row.training_result?.skenario}</TableCell>
                        <TableCell>
                          <Tooltip title="Input Hasil Training">
                            <IconButton size='small' color='primary' onClick={() => onInputFiveWhys(row)}>
                              <Edit sx={{width: "18px", height: "18px"}} />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                      {/* {row.leads.map((historyRow) => (
                        <TableRow key={historyRow.id}>
                          <TableCell component="th" scope="row">
                            {historyRow.fromName}
                          </TableCell>
                          <TableCell>{Global.maskPhoneNumber(historyRow.from)}</TableCell>
                          <TableCell><div className={Global.getLabelClasses(historyRow.label)}>{historyRow.label}</div></TableCell>
                          <TableCell align="left">{Global.formatDateTimeToStrDateTime24(historyRow.created_at)}</TableCell>
                          <TableCell>{Global.formatTime(historyRow.avgResponseTime)}</TableCell>
                        <TableCell>
                          <Tooltip title="Input hasil FU">
                            <IconButton size='small' color='primary' onClick={() => onInputFiveWhys(historyRow)}>
                              <Edit sx={{width: "18px", height: "18px"}} />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Lihat Chat">
                              <QuestionAnswer style={{cursor: "pointer"}} className="text-danger" onClick={() => {props.handleShowMessages(historyRow.contactFormatted)}}  />
                          </Tooltip>
                        </TableCell>
                        </TableRow>
                      ))} */}
                    </TableBody>
                  </Table>
                </Box>
              </Paper>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }